// 中文作文類別系統性組織
export const essayCategories = [
  {
    id: 'narrative',
    name: '記敘文',
    description: '記述人物、事件、場景的文章，以時間為主線展開',
    color: 'bg-blue-100 text-blue-800',
    icon: '📖'
  },
  {
    id: 'descriptive',
    name: '描寫文',
    description: '詳細描述人物、景物、場面的文章',
    color: 'bg-green-100 text-green-800',
    icon: '🖼️'
  },
  {
    id: 'expository',
    name: '說明文',
    description: '解釋事物性質、特點、功能等的文章',
    color: 'bg-purple-100 text-purple-800',
    icon: '📋'
  },
  {
    id: 'argumentative',
    name: '議論文',
    description: '表達觀點、論證道理的文章',
    color: 'bg-red-100 text-red-800',
    icon: '⚖️'
  },
  {
    id: 'practical',
    name: '應用文',
    description: '日常生活和工作中使用的實用文體',
    color: 'bg-orange-100 text-orange-800',
    icon: '📝'
  },
  {
    id: 'letter',
    name: '書信',
    description: '個人或正式的書信往來',
    color: 'bg-indigo-100 text-indigo-800',
    icon: '✉️'
  },
  {
    id: 'diary',
    name: '日記',
    description: '記錄日常生活、思想感受的文章',
    color: 'bg-yellow-100 text-yellow-800',
    icon: '📔'
  },
  {
    id: 'report',
    name: '報告',
    description: '工作、學習、調查等方面的報告文書',
    color: 'bg-teal-100 text-teal-800',
    icon: '📊'
  },
  {
    id: 'speech',
    name: '演講稿',
    description: '公開演講或發言的稿件',
    color: 'bg-pink-100 text-pink-800',
    icon: '🎤'
  },
  {
    id: 'review',
    name: '評論',
    description: '對作品、事件、現象的評析文章',
    color: 'bg-cyan-100 text-cyan-800',
    icon: '📰'
  },
  {
    id: 'proposal',
    name: '建議書',
    description: '提出建議或方案的正式文件',
    color: 'bg-violet-100 text-violet-800',
    icon: '💡'
  },
  {
    id: 'notice',
    name: '通知',
    description: '告知事項的公告文書',
    color: 'bg-emerald-100 text-emerald-800',
    icon: '📢'
  },
  {
    id: 'summary',
    name: '總結',
    description: '對工作、學習、活動等的總結性文章',
    color: 'bg-gray-100 text-gray-800',
    icon: '📑'
  }
];

// 根據類型獲取類別的輔助函數
export const getCategoryByType = (type) => {
  return essayCategories.find(cat => cat.id === type) || essayCategories[0];
};

// 獲取所有類別類型的輔助函數
export const getAllCategoryTypes = () => {
  return essayCategories.map(cat => cat.id);
}; 